/* tslint:disable */
/* eslint-disable */
/**
 * Alobacsi API
 * The Alobacsi API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkingTime
 */
export interface WorkingTime {
    /**
     * 
     * @type {number}
     * @memberof WorkingTime
     */
    startTime: number;
    /**
     * 
     * @type {number}
     * @memberof WorkingTime
     */
    endTime: number;
}

/**
 * Check if a given object implements the WorkingTime interface.
 */
export function instanceOfWorkingTime(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "startTime" in value;
    isInstance = isInstance && "endTime" in value;

    return isInstance;
}

export function WorkingTimeFromJSON(json: any): WorkingTime {
    return WorkingTimeFromJSONTyped(json, false);
}

export function WorkingTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkingTime {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}

export function WorkingTimeToJSON(value?: WorkingTime | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'startTime': value.startTime,
        'endTime': value.endTime,
    };
}

